<template>
  <div class= "preHouseholdInfoManageList">
    <div class="filters">
      <el-form :inline="true" :model="form" ref="form">
        <el-form-item>
          <el-select @change="selectUnit" v-model="form.houseId" filterable>
            <el-option key :label="$t('lang.lab_selectHouse')" value=""></el-option>
            <el-option
              v-for="(item,index) in houses"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select @change="selectRoom" v-model="form.unitId" filterable>
            <el-option key :label="$t('lang.lab_selectUnit')" value=""></el-option>
            <el-option
              v-for="(item,index) in units"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.roomId" filterable>
            <el-option key :label="$t('lang.lab_selectRoom')" value=""></el-option>
            <el-option
              v-for="(item,index) in rooms"
              :key="index"
              :value="item.id"
              :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input :placeholder="$t('lang.lab_preHouseholdNameOrPhone')" v-model="form.key"></el-input>  
        </el-form-item>
				<el-form-item>
					<el-input :placeholder="$t('lang.lab_carNumber')" v-model="form.carNumber"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input :placeholder="$t('lang.lab_parkingNumber')" v-model="form.carParkNumber"></el-input>
				</el-form-item>
				<el-button type="primary" @click="clear">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.preHouseholdInfoManageListcheckbox"></el-table-column>
        <el-table-column prop="id" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column
          prop="name"
          :label="$t('lang.lab_preHouseholdName')" >
        </el-table-column>
        <el-table-column
          prop="mobile"
          :label="$t('lang.lab_preHouseholdPhone')" >
        </el-table-column>
		<el-table-column
          prop="houseName"
          :label="$t('lang.lab_buildingnum')" >
        </el-table-column>
         <el-table-column
          prop="unitName"
          :label="$t('lang.lab_unitnum')" >
        </el-table-column>
        <el-table-column prop="roomId" :label="$t('lang.lab_roomnum')">
			<template slot-scope="scope"
							v-if="scope&&scope.row.gardenGrid">{{scope.row.gardenGrid.name}}</template>
		</el-table-column>
        <el-table-column
          fixed="right"
          prop="opration"
          :label="$t('lang.lab_operation')" 
         :width="require('@/config/enum').opr_width1"
         >
          <template slot-scope="scope">
            <el-button @click="carManagerDialog(scope.row.id,scope.row.roomId)">{{$t('lang.lab_carNum')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
		
		<!-- 车辆管理Dialog -->
		<el-dialog :title="$t('lang.lab_carNum')" v-if="carManageDialog" :visible.sync="carManageDialog" :close-on-click-modal='false'>
				<el-form :model="carUserForm" :rules="ruleCarUser" ref="carUserForm" style="width: 30%;" :label-width="require('@/config/enum').c_ws4"
				:label-suffix="require('@/config/enum').c_colon">
				<!-- 所属停车场 -->
				<el-form-item :label="$t('lang.lab_ownerPark')" prop="parkId">
					<el-select v-model="parkId" :placeholder="$t('lang.plh.sel')" @change="selPark(parkId)">
						<el-option v-for='(item,index) in parkList' :key="index" :label="item.parkName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
					<!-- 拥有车位数 -->
					<el-form-item :label="$t('lang.lab_ownerCarNum')" prop="placeCount">
							<el-input-number v-model.number="carUserForm.placeCount" size="small" controls-position="right" :min="0" :max="999" disabled="true"></el-input-number>
					</el-form-item>
					<!-- 租售情况 -->
					<el-form-item :label="$t('lang.lab_carRentAndSale')" prop="saleInfo">
						<el-radio-group v-model="carUserForm.saleInfo">
							<el-radio :label="0">{{$t('lang.lab_carLease')}}</el-radio>
							<el-radio :label="1">{{$t('lang.lab_carSell')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="备注" prop="remark" class="editor-width">
						<el-input type="textarea" v-model="carUserForm.remark" :rows="2" class="replyCon"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="saveCarUser(carUserForm)" :disabled="parkId==''||tableEditState==1">保存业主信息</el-button>
					</el-form-item>
				</el-form>
				<hr style="border: 0; background-color: #DCDFE6; height: 1px;" />
				<el-card>
					<el-button slot="header" size="medium" type="primary" @click="addCarNum" :disabled="parkId==''||tableEditState==1">{{$t('lang.lab_addCarNum')}}</el-button><br />
					<!-- 车牌号 -->
					<el-table :data="carNumTable" class="wid100" :row-class-name="tableRowClassName" max-height="300">
						<el-table-column prop="carNum" :label="$t('lang.lab_carNumber')">
							<template slot-scope="scope">
								<el-select v-show="scope.row.showEdit" class="citySelect fs-20 mt-5" v-model="scope.row.city" :disabled="tableIsEditState==1" @change="changeCity">
        					<el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      					</el-select>
								<el-input class="smallInput"  v-model="scope.row.car" v-show="scope.row.showEdit" :placeholder="$t('lang.lab_pleCarNum')" :disabled="tableIsEditState==1"></el-input>
								<span v-show="!scope.row.showEdit">{{scope.row.carNum}}</span>
							</template>
						</el-table-column>
						<!-- 车辆状态 -->
						<el-table-column prop="carState" :label="$t('lang.lab_carStatus')">
							<template slot-scope="scope">
								<span v-show="!scope.row.showEdit" v-if="scope.row.carState == 1">{{$t('lang.lab_normalStatus')}}</span>
								<span v-show="!scope.row.showEdit" v-if="scope.row.carState == 0">{{$t('lang.lab_cancellation')}}</span>
								
								<el-select v-model="scope.row.carState" v-show="scope.row.showEdit" :placeholder="$t('lang.plh.sel')+$t('lang.lab_carStatus')">
									<el-option :label="$t('lang.lab_normalStatus')" :value="1"></el-option>
									<el-option :label="$t('lang.lab_cancellation')" :value="0"></el-option>
								</el-select>
								<!-- <el-input size="small" v-model="scope.row.carState" v-show="scope.row.showEdit" :placeholder="$t('lang.lab_pleCarNum')"></el-input> -->
								<!-- <span v-show="!scope.row.showEdit">{{scope.row.carState}}</span> -->
							</template>
						</el-table-column>
						
						<el-table-column prop="carType" :label="$t('lang.lab_carType')">
							<template slot-scope="scope">
								<span v-show="!scope.row.showEdit" v-if="scope.row.carType == 1">{{$t('lang.lab_monthlyRent')}}</span>
								<span v-show="!scope.row.showEdit" v-if="scope.row.carType == 2">{{$t('lang.lab_storeCar')}}</span>
								
								<el-select v-model="scope.row.carType" v-show="scope.row.showEdit" :placeholder="$t('lang.plh.sel')+$t('lang.lab_carType')">
									<el-option :label="$t('lang.lab_monthlyRent')" :value="1"></el-option>
									<el-option :label="$t('lang.lab_storeCar')" :value="2"></el-option>
								</el-select>
								<!-- <el-input size="small" v-model="scope.row.carState" v-show="scope.row.showEdit" :placeholder="$t('lang.lab_pleCarNum')"></el-input> -->
								<!-- <span v-show="!scope.row.showEdit">{{scope.row.carState}}</span> -->
							</template>
						</el-table-column>

						<el-table-column :label="$t('lang.lab_operation')">
							<template slot-scope="scope">
								<el-button class="tableButton" @click="saveAndEditTable(scope.$index, scope.row)">{{scope.row.showEdit?$t('lang.btn_save'):$t('lang.btn.modifyBtn')}}</el-button>
								<el-button class="tableButton" :disabled="tableEditState==1" @click="delCar(scope.row.id)">{{scope.row.showEdit?'':$t('lang.btn.deleteBtn')}}</el-button>
							</template>
						</el-table-column>
					</el-table>
					
				</el-card>
				<br />
				<div slot="footer" class="dialog-footer">
					<el-button @click="carManageDialog = false">{{$t('lang.btn_backpage')}}</el-button>
					<!--<el-button type="primary" @click="saveCarUser(carUserForm)" :disabled="parkId==''||tableEditState==1">{{$t('lang.btn_save')}}</el-button>-->
				</div>
		</el-dialog>
  </div>
</template>

<script>
// 引入富文本title汉字
// eslint-disable-next-line no-unused-vars
import { excelDownload } from '../../../config/download.js'
/**
 *@ClassName:preHouseholdInfoManageList
 *@Description:原始住户数据管理
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-12
 */
import { mapGetters } from 'vuex'

export default {
	name: '/manage/main.carUserList',
  data() {
		var validateParkId = (rule, value, callback) => {
				if (this.parkId == '' || this.parkId == null || this.parkId == undefined) {
					return callback(new Error(this.$i18n.t('lang.lab_selPark')))
				} else {
					callback()
				}
		}
    return {
      type: 1, // 1:楼 2：单元 3：房间
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
      form: { 
        houseId: '', // 楼号
        unitId: '', // 单元号
        roomId: '', // 房间号 
        key: '', // 关键词
        id: '', // 序号
				carNumber: '', // 车牌号
				carParkNumber: ''
      },
      houses: [], //  存储根据小区请求回来的楼号
      units: [], //  存储根据楼号请求回来的单元
      rooms: [], //  存储根据单元请求回来的房间号
      tableData: [], // 列表数据
      preHouseholdInfoManageListcheckbox: require('@/config/enum').preHouseholdInfoManageListcheckbox, // 是否隐藏复选框
			
			userSaveData: '',
			ownerId: '',
			roomId: '',
			parkId: '', // 车场Id
			carManageDialog: false, // 是否显示车辆管理dialog
			parkList: [], // 车场数据
			carUserForm: {
				id: '',
				placeCount: undefined, // 车位数
				saleInfo: '', // 租售情况 0出租 1出售
				remark: '',
				addOrEdit: '', // 添加/修改 1添加 2修改 
				isSave: 1 // 0不保存 1保存
			},
			carNumForm: {
				id: '',
				carNum: '', // 车牌号
				carState: '', // 车辆状态 1正常 0注销
				carType: '', // 车辆类型 1月租 0储值
				addOrEdit: '' // 添加/修改 1添加 2修改
			},
			carNumTable: [],
			tableEditState: 0, // 表格是否编辑中 0否 1是
			tableIsEditState: 0,
			
			ruleCarUser: {
				parkId: [{ required: true, validator: validateParkId }],
				placeCount: [{ required: true, message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_placeCount') },
											{ type: 'number', message: this.$i18n.t('lang.key_appOrderBy') }],
				saleInfo: [{ required: true, message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_carRentAndSale'), trigger: 'change' }]
			},
			cityList: [{
            value: '辽',
            label: '辽'
          },
          {
            value: '吉',
            label: '吉'
          },
          {
            value: '黑',
            label: '黑'
          },
          {
            value: '蒙',
            label: '蒙'
          },
          {
            value: '京',
            label: '京'
          },
          {
            value: '津',
            label: '津'
          },
          {
            value: '冀',
            label: '冀'
          },
          {
            value: '沪',
            label: '沪'
          },
          {
            value: '渝',
            label: '渝'
          },
          {
            value: '豫',
            label: '豫'
          },
          {
            value: '云',
            label: '云'
          },
          {
            value: '湘',
            label: '湘'
          },
          {
            value: '鲁',
            label: '鲁'
          },
          {
            value: '新',
            label: '新'
          },
          {
            value: '苏',
            label: '苏'
          },
          {
            value: '浙',
            label: '浙'
          },
          {
            value: '赣',
            label: '赣'
          },
          {
            value: '鄂',
            label: '鄂'
          },
          {
            value: '桂',
            label: '桂'
          },
          {
            value: '甘',
            label: '甘'
          },
          {
            value: '晋',
            label: '晋'
          },
          {
            value: '陕',
            label: '陕'
          },
					{
            value: '皖',
            label: '皖'
          },
          {
            value: '闽',
            label: '闽'
          },
          {
            value: '贵',
            label: '贵'
          },
          {
            value: '青',
            label: '青'
          },
          {
            value: '粤',
            label: '粤'
          },
          {
            value: '藏',
            label: '藏'
          },
          {
            value: '川',
            label: '川'
          },
          {
            value: '宁',
            label: '宁'
          },
          {
            value: '琼',
            label: '琼'
          },
          {
            value: '使',
            label: '使'
          },
          {
            value: '领',
            label: '领'
          },
					{
            value: '电',
            label: '电'
          },
        ], // 城市列表
				newCarNum: ''
    }
  },
	computed: {
    ...mapGetters(['gardenId'])
  },
  created() {
    this.selectHouse(this.gardenId)
    this.getData()
  },
	watch: {
		carUserForm: {
			handler(newVal, oldVal) {
				var newValue = {
					placeCount: newVal.placeCount,
					saleInfo: newVal.saleInfo,
					remark: newVal.remark
				}
				let tempRule = JSON.stringify(newValue)
				
				if (tempRule === this.userSaveData) {
					this.carUserForm.isSave = 0
				} else {
					this.carUserForm.isSave = 1
				}
			},
			deep: true,
			immediate: true
		}
	},
  methods: {
    // 获取数据
    getData() {
      let loading = this.$loading()
      this.$get(`/roomOwner/page?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&fjType=0&fjName=`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // id查询楼号楼层房间号
    gardenGrids(type, id) {
      if (id === '') return
      this.$get(`/gardenGrids/?type=${this.type}&parentId=${id}&pageNo=1&pageSize=9999`).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.type === 1) {
              this.houses = res.list
            } else if (this.type === 2) {
              this.units = res.list
            } else if (this.type === 3) {
              this.rooms = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 根据小区选择获取楼号
    selectHouse(id) {
      this.type = 1
      this.form.houseId = ''
      this.form.unitId = ''
      this.form.roomId = ''
      this.houses = []
      this.units = []
      this.rooms = []
      this.gardenGrids(this.type, id)
    },
    // 根据楼号选择获取单元
    selectUnit(id) {
      this.type = 2
      this.form.unitId = ''
      this.form.roomId = ''
      this.units = []
      this.rooms = []
      this.gardenGrids(this.type, id)
    },
    // 根据单元选择获取房间
    selectRoom(id) {
      this.type = 3
      this.rooms = []
      this.form.roomId = ''
      this.gardenGrids(this.type, id)
    },
		// 情况清空
		clear() {
			this.form.houseId = ''
			this.form.unitId = ''
			this.form.roomId = ''
			this.form.key = ''
			this.form.carNumber = ''
		},
    // 查询
    commit() {
      this.pageNo = 1
      this.search()
    }, 
    // 筛选
    search() {
      this.$get(`/roomOwner/page?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.form.houseId}&unitId=${this.form.unitId}&roomId=${this.form.roomId}&key=${this.form.key}&id=${this.form.id}&carNumber=${this.form.carNumber}&carParkNumber=${this.form.carParkNumber}&fjType=0&fjName=`).then(
        res => {
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.search()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.search()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
		
		// 打开车辆管理Dialog
		carManagerDialog(ownerId, roomId) {
			this.ownerId = ownerId
			this.roomId = roomId
			this.carManageDialog = true
			this.parkId = ''
			this.carUserForm.placeCount = undefined
			this.carUserForm.saleInfo = ''
			this.carUserForm.remark = ''
			this.carNumTable = []
			this.tableEditState = 0
			this.tableIsEditState = 0
			
			var loading = this.$loading()
			/* 查询car_park */
			this.$get(`/carPark?pageNo=1&pageSize=99&gardenId=` + this.gardenId)
			.then(
			res => {
				loading.close()
				this.parkList = res.list
				console.log(this.parkList)
				if (res.list.length > 0) {
					this.parkId = res.list[0].id
					this.selPark(res.list[0].id)
				}
			},
			err => {
				loading.close()
				this.$message.error(err)
			})
		},
		selPark(parkId) {
			this.parkId = parkId
			var loading = this.$loading()
			/* 查询car_user */
			this.$get(`/carUser/` + this.ownerId + '/' + this.roomId + '/' + parkId)
			.then(
			res => {
				var saveUser
				if (res.msg != undefined && res.msg != null && res.msg != '') {
					this.$message.warning(res.msg)
					this.carUserForm.placeCount = 0
					this.carUserForm.saleInfo = 1
					this.carUserForm.remark = ''
					this.carUserForm.addOrEdit = 1
					
					saveUser = {
						placeCount: this.carUserForm.placeCount,
						saleInfo: this.carUserForm.saleInfo,
						remark: this.carUserForm.remark
					}
					this.userSaveData = JSON.stringify(saveUser)
				} else {
					this.carUserForm.id = res.Id
					this.carUserForm.placeCount = res.PlaceCount
					this.carUserForm.saleInfo = res.SaleInfo
					this.carUserForm.remark = res.Remark
					this.carUserForm.addOrEdit = 2
					
					saveUser = {
						placeCount: this.carUserForm.placeCount,
						saleInfo: this.carUserForm.saleInfo,
						remark: this.carUserForm.remark
					}
					this.userSaveData = JSON.stringify(saveUser)
				}
				loading.close()
			},
			err => {
				loading.close()
				this.$message.error(err)
			})
			/* 查询car_num */
			this.$get(`/carNum?pageNo=1&pageSize=999&roomId=${this.roomId}&ownerId=${this.ownerId}&parkId=${parkId}`)
			.then(
			res => {
				for (let a in res.list) {
					res.list[a].showEdit = false
					res.list[a].city = res.list[a].carNum.substr(0, 1)
					res.list[a].car = res.list[a].carNum.substr(1, res.list[a].carNum.length)
				}
				this.carNumTable = res.list
				loading.close()
			},
			err => {
				loading.close()
				this.$message.error(err)
			})
		},
		selCarNum(parkId) {
			var loading = this.$loading()
			/* 查询car_num */
			this.$get(`/carNum?pageNo=1&pageSize=999&roomId=${this.roomId}&ownerId=${this.ownerId}&parkId=${parkId}`)
			.then(
			res => {
				for (let a in res.list) {
					res.list[a].showEdit = false
					res.list[a].city = res.list[a].carNum.substr(0, 1)
					res.list[a].car = res.list[a].carNum.substr(1, res.list[a].carNum.length)
				}
				this.carNumTable = res.list
				loading.close()
			},
			err => {
				loading.close()
				this.$message.error(err)
			})
		},
		/* 添加车辆 */
		addCarNum() {
			this.tableEditState = 1
			this.tableIsEditState = 0
			this.carNumTable.push({
				showEdit: true,
				carNum: '',
				city: '辽',
				car: 'A',
				carState: 1,
				carType: 1,
				addOrEdit: 1 // 标记是否添加
			})
		},
		/* 删除车辆 */
		delCar(id) {
			/* var loading = this.$loading() 
			this.$delete(`carNum/` + id).then(
				res => {
					loading.close()
					this.$message.success(this.$t('lang.lab_del_success'))
					this.selPark(this.parkId)
				},
				err => {
					loading.close()
					this.$message.error(err)
				}
			) */
				let loading = this.$loading()
				this.$confirm(
					this.$i18n.t('lang.lab_isdelete'),
					this.$i18n.t('lang.lab_prompt'),
					{
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						cancelButtonText: this.$i18n.t('lang.btn_cancel'),
						type: 'warning'
					}
				).then(() => {
						this.$delete(`carNum/` + id).then(
							res => {
								loading.close()
								if (res && res.errCode === 0) {
									this.$message({
										type: 'success',
										message: this.$i18n.t('lang.lab_del_success')
									})
									this.selCarNum(this.parkId)
								}
							},
							error => {
								loading.close()
								this.$message.error(error)
							}
						)
					})
					.catch(() => {
						loading.close()
						this.$message({
							type: 'info',
							message: this.$i18n.t('lang.lab_del_can')
						})
					})
		},
		/* 表格编辑 */
		saveAndEditTable(index, row) {
			console.log('aaaaaaa')
			console.log(this.parkId)
			this.carNumForm.addOrEdit = 2
			this.tableEditState = 1
			this.tableIsEditState = 1
			row.showEdit = !row.showEdit
			var loading = this.$loading()
			if (!row.showEdit) {
				const reg = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[a-zA-Z](([DABCEFGHJK]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DABCEFGHJK]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领电A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
				this.newCarNum = row.city + row.car
				if ((!reg.test(this.newCarNum)) || this.newCarNum == '') {
					this.$alert(this.$i18n.t('lang.lab_pleRightCarNum'), this.$i18n.t('lang.lab_prompt'), {
						confirmButtonText: this.$i18n.t('lang.btn_confirm'),
						type: 'warning'
					})
					.then(() => {
						loading.close()
						// this.selPark(this.parkId)
						this.carNumTable = []
						this.tableEditState = 0
						this.tableIsEditState = 0
					}).catch(() => {
						loading.close()
						this.carNumTable = []
						this.tableEditState = 0
						this.tableIsEditState = 0
					})
				} else {
					if (row.addOrEdit != undefined && row.addOrEdit != null && row.addOrEdit != '') {
						this.$post(`carNum`, {
							carNum: this.newCarNum,
							gardenId: this.gardenId,
							ownerId: this.ownerId,
							roomId: this.roomId,
							parkId: this.parkId,
							carType: row.carType,
							carState: row.carState
						}).then(
							res => {
								if (this.carUserForm.addOrEdit === 1) {
									this.$post(`carUser`, {
										gardenId: this.gardenId,
										ownerId: this.ownerId,
										roomId: this.roomId,
										parkId: this.parkId,
										placeCount: this.carUserForm.placeCount == '' ? 0 : this.carUserForm.placeCount,
										saleInfo: this.carUserForm.saleInfo == '' ? 1 : this.carUserForm.saleInfo,
										remark: this.carUserForm.remark
									}).then(										
										res => {
											this.selPark(this.parkId)
										},
									)
								}
								if (this.carUserForm.addOrEdit === 2) {
									this.$patch(`carUser/` + this.carUserForm.id, {
										placeCount: this.carUserForm.placeCount,
										saleInfo: this.carUserForm.saleInfo,
										remark: this.carUserForm.remark
									}).then(										
										res => {
											this.selPark(this.parkId)
										},
									)
								}
								loading.close()
								this.$message.success(this.$t('lang.lab_save_success'))
								// this.selPark(this.parkId)
								this.selCarNum(this.parkId)
								this.tableEditState = 0
								this.tableIsEditState = 0
							},
							err => {
								loading.close()
								this.$message.error(err)
								this.selCarNum(this.parkId)
								this.tableEditState = 0
								this.tableIsEditState = 0
							}
						)
					} else {
						this.$patch(`carNum/` + row.id, {
							parkId: this.parkId,
							carNum: this.newCarNum,
							carType: row.carType,
							carState: row.carState
						}).then(							
							res => {
								if (this.carUserForm.addOrEdit === 1) {
									this.$post(`carUser`, {
										gardenId: this.gardenId,
										ownerId: this.ownerId,
										roomId: this.roomId,
										parkId: this.parkId,
										placeCount: this.carUserForm.placeCount == '' ? 1 : this.carUserForm.placeCount,
										saleInfo: this.carUserForm.saleInfo == '' ? 1 : this.carUserForm.saleInfo,
										remark: this.carUserForm.remark
									}).then(										
										res => {
											this.selPark(this.parkId)
										},
									)
								}
								if (this.carUserForm.addOrEdit === 2) {
									this.$patch(`carUser/` + this.carUserForm.id, {
										placeCount: this.carUserForm.placeCount,
										saleInfo: this.carUserForm.saleInfo,
										remark: this.carUserForm.remark
									}).then(										
										res => {
											this.selPark(this.parkId)
										},
									)
								}
								loading.close()
								this.$message.success(this.$t('lang.lab_save_success'))
								this.selCarNum(this.parkId)
								this.tableEditState = 0
								this.tableIsEditState = 0
							},
							err => {
								loading.close()
								this.selCarNum(this.parkId)
								this.$message.error(err)
								this.tableEditState = 0
								this.tableIsEditState = 0
							}
						)
					}
				}
			} else {
				loading.close()
			}
		},
		/* 保存用户信息 */
		saveCarUser(carUserForm) {
			console.log(carUserForm.addOrEdit)
			console.log(carUserForm.isSave)
			this.$refs.carUserForm.validate(vaild => {
				if (vaild) {
					// this.carManageDialog = false
					var loading = this.$loading()
					if (carUserForm.addOrEdit === 1) {
						this.$post(`carUser`, {
							gardenId: this.gardenId,
							ownerId: this.ownerId,
							roomId: this.roomId,
							parkId: this.parkId,
							placeCount: carUserForm.placeCount,
							saleInfo: carUserForm.saleInfo,
							remark: carUserForm.remark
						}).then(
							res => {
								this.selPark(this.parkId)
								loading.close()
								this.$message.success(this.$t('lang.lab_save_success'))
							},
							err => {
								loading.close()
								this.$message.error(err)
							}
						)
					} else if (carUserForm.addOrEdit === 2) {
						this.$patch(`carUser/` + carUserForm.id, {
							placeCount: carUserForm.placeCount,
							saleInfo: carUserForm.saleInfo,
							remark: carUserForm.remark
						}).then(
							res => {
								this.selPark(this.parkId)
								loading.close()
								this.$message.success(this.$t('lang.lab_save_success'))
							},
							err => {
								loading.close()
								this.$message.error(err)
							}
						)
					} else {
						loading.close()
					}
				}
			})
		},
		// 如果车牌省份为‘电’，车牌首位字母默认为‘D’
		changeCity(e) {
			if (e == '电') {
				this.carNumTable[this.carNumTable.length - 1].car = 'D'
			}
		},
		
  }
}
</script>

<style lang= 'scss' scoped>
	.el-card .el-card__header{
		text-align: right;
		padding:10px 10px 0px 10px;
		border-bottom: 0;
		border: 0;
	}
	.tableButton{
		width: 40px!important;
		padding: 0px!important;
		background-color: transparent!important;
	}
	.tableButton:hover{
		background-color: transparent!important;
		color: #00b1c3!important;
	}
	.el-dialog__wrapper{
		height: 100%;
	}
	.citySelect {
		display: inline-block;
    width: 70px !important;
		margin-right: 5px;
  }
	.smallInput{
		width: 60% !important;
	}
	.replyCon {
      width: 600px;
    }
</style>